import { GlobalEvent } from '../models/events/GlobalEvent';
import { TGlobalEventSubscription } from '../models/events/TGlobalEventSubscription';
import { TGlobalEvent } from '../models/events/TGlobalEvent';

export class GlobalEventStore {
	subscriptionsByGlobalEvent: { [key in GlobalEvent]?: TGlobalEventSubscription[] } = {};
	public getSubscribers(event: GlobalEvent) {
		return this.subscriptionsByGlobalEvent && this.subscriptionsByGlobalEvent[event];
	}
	public subscribe(subscription: TGlobalEventSubscription) {
		if (!this.subscriptionsByGlobalEvent) {
			this.subscriptionsByGlobalEvent = {};
		}
		const { event, subscriptionId } = subscription;
		if (!this.subscriptionsByGlobalEvent[event]) {
			this.subscriptionsByGlobalEvent[event] = [];
		}

		if (!subscriptionId || !this.subscriptionsByGlobalEvent[event].find(existingSubscription => existingSubscription.subscriptionId === subscriptionId)) {
			this.subscriptionsByGlobalEvent[event].push(subscription);
			console.info(`Global Events: Subscription added for: ${event}`);
		}
	}
	public publish(eventWithPayload: TGlobalEvent) {
		const { event, payload } = eventWithPayload;
		console.info(`Global Events: Publish fired for: ${event}`, { payload: payload && JSON.parse(JSON.stringify(payload)) });
		const subscribers = this.getSubscribers(event);
		console.info(`Global Events: ${(subscribers && subscribers.length) || 0} subscribers for: ${event}`);
		if (subscribers) {
			subscribers.forEach((subscriber) => {
				subscriber.onPublish(payload as any);
			});
		}
	}
}